import WorkloadColor from "./workload-color";

export default class Workload {

    constructor(data) {
        this.date = null;
        this.duration = 0;
        this.percentage = 0;
        this.maxDuration = 0;
        this.bookings = 0;
        this.colors = [];
        this.resources = [];

        if (data) {
            Object.assign(this, data);

            if (this.colors) {
                this.colors = this.colors.map(colorData => new WorkloadColor(colorData));
            }

            /*
             if (this.resources && this.resources.length > 0) {
             this.resources = _(this.resources).map(resourceWorkloadData => {

             });
             }
             */
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/workload.model.js